import { Box, Grid, Link, Stack, SvgIcon, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BRAND_NAME, HELP_SUPPORT_URL } from "@constants";
import { IconInfos } from "@features/cart/components/IconInfos/IconInfos";
import RetryIcon from "@static/icons/Retry.svg";
import HelpIcon from "@static/icons/Help.svg";
import { ChangeAddressLink } from "@common/ChangeAddressLink/ChangeAddressLink";

interface IParams {
    handleChangeAddress(): void;
}

export const HomeBroadbandAlreadyHave = (props: IParams) => {
    const { handleChangeAddress } = props;
    const { t } = useTranslation(["home", "common"]);

    const renderHelpSupportLink = (text: string) => (
        <Link color="primary" href={`${HELP_SUPPORT_URL}`} rel="noopener" target="_blank" underline="always">
            {text}
        </Link>
    );

    return (
        <Stack alignItems="center" maxWidth={571} padding={4} spacing={2}>
            <Typography align="center" color="secondary" maxWidth={450} variant="h2">
                {t("home:alreadyHaveBroadband", { brand: BRAND_NAME })}
            </Typography>
            <Box paddingTop={2}>
                <Typography align="center" color="secondary" paddingBottom={3} variant="large">
                    {t("home:dontHaveBroadbandHelp", { brand: BRAND_NAME })}
                    {renderHelpSupportLink(t("common:here"))}
                </Typography>
                <Grid container paddingTop={3} spacing={2}>
                    <Grid item xs={12}>
                        <IconInfos
                            icon={<SvgIcon component={RetryIcon} inheritViewBox />}
                            linkComponent={<ChangeAddressLink handleChangeAddress={handleChangeAddress} />}
                            text={t("home:tryDifferentAddress")}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <IconInfos
                            icon={<SvgIcon component={HelpIcon} inheritViewBox />}
                            linkComponent={
                                <Typography minWidth={100} variant="normal">
                                    {renderHelpSupportLink(t("common:lookForHelp"))}
                                </Typography>
                            }
                            text={t("home:notSureOfActiveBroadband", { brand: BRAND_NAME })}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Stack>
    );
};
